import type { ComponentProps } from 'react'
import { forwardRef } from 'react'
import { FOCUS_RING } from '@/lib/focus-ring'
import { cn } from '@/lib/utils'

const NON_SPELLCHECK_TYPES = new Set([
  'password',
  'email',
  'url',
  'tel',
  'number',
  'search',
  'date',
  'time',
  'datetime-local',
  'month',
  'week',
  'color',
  'file',
  'hidden',
])

const Input = forwardRef<HTMLInputElement, ComponentProps<'input'>>(
  ({ className, type, spellCheck, ...props }, ref) => {
    const resolvedSpellCheck =
      spellCheck ?? (type && NON_SPELLCHECK_TYPES.has(type) ? false : true)
    return (
      <input
        type={type}
        spellCheck={resolvedSpellCheck}
        className={cn(
          'rounded-control flex h-8 w-full px-3 py-1 text-base transition-colors duration-200 ease-out md:text-sm',
          'border border-border/50 bg-transparent text-foreground',
          'hover:border-border/80',
          'focus:border-primary/60',
          FOCUS_RING,
          'file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground',
          'placeholder:text-muted-foreground/50',
          'disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        ref={ref}
        {...props}
      />
    )
  },
)
Input.displayName = 'Input'

export { Input }
